import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { UserInitEffects } from './user-init.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([UserInitEffects])],
})
export class UserInitModule {}
